import { useMemo } from 'react';

import { createDateDurationString } from '@/utils/createDateDurationString';
import { createItineraryBlockDayString } from '@/utils/createItineraryBlockDayString';

import { ItineraryService } from './ItineraryService/ItineraryService';
import {
  StyledItineraryBlockCardWrapper,
  StyledItineraryBlockCardHeader,
  StyledItineraryBlockBody,
  StyledItineraryBlockCardHeaderTitle,
} from './styles';

import { Paragraph } from '../Paragraph';

import type { ItineraryBlock } from '@/types/itinerary';

interface ItineraryBlockCardProps {
  itineraryBlock: ItineraryBlock;
}

function ItineraryBlockCard({ itineraryBlock }: ItineraryBlockCardProps) {
  const dayString = useMemo(() => createItineraryBlockDayString(itineraryBlock), [itineraryBlock]);
  const dateString = useMemo(
    () => createDateDurationString(itineraryBlock.startDate, itineraryBlock.endDate),
    [itineraryBlock],
  );

  return (
    <StyledItineraryBlockCardWrapper>
      <StyledItineraryBlockCardHeader>
        <StyledItineraryBlockCardHeaderTitle>{dayString}</StyledItineraryBlockCardHeaderTitle>
        <Paragraph color="white" size="md" weight={400}>
          {dateString}
        </Paragraph>
      </StyledItineraryBlockCardHeader>
      <StyledItineraryBlockBody>
        <ItineraryService itineraryBlock={itineraryBlock} />
      </StyledItineraryBlockBody>
    </StyledItineraryBlockCardWrapper>
  );
}

export { ItineraryBlockCard };
